module.exports = __webpack_public_path__ + "img/03_Store_2Scene.e31d74d2.jpg";